<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="this.consts.meetingType.florist">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color h-100 mh-515 shadow">
          <div class="pl-2 pb-2 pr-2 pt-0 h-100">
            <div class="col-7 p-0 d-inline-block">
              <h5 class="text-primary p-3">{{agendaData('title')}}</h5>
              <ul class="list-group mb-5">
                <li class="list-group-item border-0" v-for="(content, index) in agendaData('contents')" :key="index">・{{content}}</li>
              </ul>
            </div>
            <div class="col-5 p-0 d-inline-block position-absolute w-100">
              <img class="w-100" :src="imageUrl">
            </div>
            <div class="text-right position-absolute bottom-local mb-3 mr-5">
              <b-button variant="outline-primary" class="w-25 sub-button-color" @click="reload" id="reload">更新</b-button>
              <b-button variant="primary" class="w-25 ml-3 main-button-color" :disabled="isLoading" @click="nextPage" id="next">次へ</b-button>
            </div>
          </div>
        </div>
      </b-overlay>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import AgendaModel from '@/models/AgendaModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import fstore from '@/store/florist-store'
import mstore from '@/store/meeting-store'

export default {
  name: 'FloristMeetingAgenda',
  components: { CommonLayout, MeetingLayout, CommonModal },
  data () {
    return {
      overlayShow: false,
      isSendFirstSignalingData: false,
      isCustomerRegistered: false,
      isLoading: true,
      imageUrl: ''
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsTargetAtendeeActive () {
      // 打合せ相手との疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['event'] === 'status') {
          // カスタマーがアジェンダ画面表示したか
          if (newData['data']['show_agenda_view'] === 'success') {
            // アジェンダデータをシグナリング送信
            this.sendSignalingApiData()
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  methods: {
    agendaData (key) {
      try {
        const store = AgendaModel.getStore()
        if (!store) {
          return null
        }
        return store.agenda[key]
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    setApiData: async function (isReload = false) {
      try {
        this.overlayShow = true
        const resData = await AgendaModel.apiSetStore(this.$bvModal, () => {
          this.overlayShow = false
        })
        this.isCustomerRegistered = resData.isCustomerRegistered

        if ((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) {
          this.sendSignalingApiData()
          this.isSendFirstSignalingData = true
        }
        this.isLoading = false
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingApiData () {
      try {
        const store = AgendaModel.getStore()
        if (!store) {
          return null
        }
        let apiRes = {}
        apiRes = {
          'status': store.status,
          'message': store.message,
          'agenda': store.agenda
        }
        SignalingModel.sendApiEvent('getAgenda', this, apiRes)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    nextPage: async function () {
      try {
        // cookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        const targetPath = this.isCustomerRegistered ? '/florist/meeting/hearing' : '/florist/meeting/input'
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    reload () {
      try {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  mounted () {
    this.setApiData()
    this.imageUrl = this.config.imageURL + '/meeting-contents/agenda.jpg'
  },
  destroyed () {
    if (AgendaModel.getStore()) {
      AgendaModel.removeStore()
    }
  }
}
</script>
<style scoped>
.bottom-local {
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloristMeetingAgenda.vue